import React from 'react';
import { Link } from 'react-router-dom';
import { AcademicCapIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';

export default function Formations() {
  return (
    <div className="min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Breadcrumb */}
        <Link to="/" className="inline-flex items-center text-honey-600 hover:text-honey-700 mb-8">
          <ArrowLeftIcon className="h-4 w-4 mr-2" />
          Retour à l'accueil
        </Link>

        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-honey-100 rounded-2xl mb-6">
            <AcademicCapIcon className="h-8 w-8 text-honey-600" />
          </div>
          <h1 className="text-4xl font-bold text-slate-900 mb-4">
            Nos formations
          </h1>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Perfectionnez vos compétences avec nos formations adaptées
          </p>
        </div>

        {/* Contenu à venir */}
        <div className="bg-white rounded-xl shadow-soft p-12 text-center">
          <p className="text-slate-500 text-lg">
            Cette section est en cours de développement.
          </p>
          <p className="text-slate-400 mt-2">
            Le catalogue de formations sera bientôt disponible.
          </p>
        </div>
      </div>
    </div>
  );
}
